/**
 * Sekcja "Dane odbiorcy"
 */
app.service('deliveryReceiverDetails', function (orderConfig, select, validate) {

	let $root, $receiverPhone, $phonePrefix, $receiverAddress;

	let config;

	function init($deliveryForm) {
		config = orderConfig.getData();
		setElements();
		setEvents($deliveryForm);
	}

	function setElements() {
		$root = $('#container');
		$phonePrefix = $('#receiver-phone-country-code-selector', $root);
		$receiverPhone = $('#receiver-phone', $root);
		$receiverAddress = $('#receiver-data input', $root);
	}

	function setEvents($form) {

		$phonePrefix.on('change', function () {
			validate.element($(this), $form);

			if ($receiverPhone.val().length) {
				validate.element($receiverPhone, $form);
			}
			if (hasChangedPolishPhonePrefix($(this))) {
				if ($receiverPhone.val().length) {
					$receiverPhone.val('');
					validate.element($receiverPhone, $form);
				}
			}
			$(this).data('prev-value', $(this).val());
		});

		$receiverPhone.phoneFormat();
	}

	function setForeignReceiverPhone(phonePrefix) {
		if (phonePrefix !== '+48') {
			$('input[type=radio].js-switch-receiver-data').val([true]);
			$root.addClass('hide-receiver-data-controls');
			setPolishPhonePrefixForReceiver();
		} else {
			$root.removeClass('hide-receiver-data-controls');
		}
	}

	function setPolishPhonePrefixForReceiver() {
		select.setValue({ $input: $phonePrefix, value: '+48', label: 'PL (+48)' });
	}

	function hasChangedPolishPhonePrefix($prefix) {
		const previousValue = $prefix.data('prev-value');
		const currentValue = $prefix.val();

		if (previousValue === '+48' && currentValue !== '+48') {
			return true;
		}

		return previousValue !== '+48' && currentValue === '+48';
	}

	function render() {

		const sameReceiver = config.deliveryInfo.sameReceiver;

		$root.toggleClass('hide-receiver-data', sameReceiver);
		$receiverAddress.ignore(sameReceiver);
	}

	return {
		init,
		render,
		setForeignReceiverPhone,
		setPolishPhonePrefixForReceiver
	};
});